import React from "react";

const ErrorDB = ({style = ''}) => {
    return (
        <div className={`error ${style}`}>
            <p className="error text-center">現在表示できません。しばらく経ってから再度お試しください。</p>
        </div>
    )
}

export default ErrorDB;